import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faDownload, faCamera, faStar as faStarSolid, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { ListGroup, Button } from 'react-bootstrap';
import { FilePond } from 'react-filepond';
import { fpPayload } from '../API/MainAPICall/filepondApi';
import { GetJobAttachment, DeleteJobAttachment, GetJobAttachmentList, FavoriteJobAttachment } from '../API/JobAttachments';
import Webcam from "react-webcam";

export default ({ editable = false, jobId, jobStep, title = "Attachments", ...props }) => {
    const [attachments, setAttachments] = useState([]);
    const [hideAttachments, setHideAttachments] = useState(false);

    const FACING_MODE_ENVIRONMENT = "environment";

    const [isWebcam, setWebcam] = useState(false)
    const [isWebcamFrozen, setWebcamFrozen] = useState(false)
    const [webcamImage, setWebCamImage] = useState('');
    const [webcamImageName, setWebCamImageName] = useState('');

    const webcamRef = React.useRef(null);
    const filepondRef = React.useRef(null);

    const videoConstraints = {
        width: 1920,
        height: 1080,
        renderwidth: '',
        renderheight: '',
        facingMode: FACING_MODE_ENVIRONMENT
    };
    const webcamSnapshot = React.useCallback(
        () => {
            if (!isWebcamFrozen) {
                const imageSrc = webcamRef.current.getScreenshot();
                setWebCamImage(imageSrc)
            }
            else {
                setWebCamImage('')
                setWebCamImageName('')
            }
            setWebcamFrozen(!isWebcamFrozen)
        },
        [webcamRef, isWebcamFrozen]
    );

    useEffect(() => {
        LoadAttachments(jobId, jobStep)
    }, [jobId, jobStep])

    const LoadAttachments = (argJobId, argJobStep) => {
        GetJobAttachmentList(argJobId, argJobStep)
            .then(res => { setAttachments(res.data) })
    }

    const RemoveAttachment = (id) => {
        DeleteJobAttachment(id)
            .then(res => {
                LoadAttachments(jobId, jobStep)
            })
    }

    const preventFileLoadOnMissedDragAndDrop = () => {
        window.addEventListener("dragover", function (e) {

            e.preventDefault();
        }, false);

        window.addEventListener("drop", function (e) {

            e.preventDefault();
        }, false);
    }

    const FavoriteAttachment = (attachment, idx) => {
        const updatedAttachments = [...attachments];
        updatedAttachments[idx]["favorite"] = (updatedAttachments[idx]["favorite"]) ? false : true;
        FavoriteJobAttachment(updatedAttachments[idx]).then(res => {
            if (res.success) {
                setAttachments(updatedAttachments);
            }
        })
    }

    const renderUpload = () => {
        if (editable) {
            return <div className="attachment-container">
                <div className="attachment-camera clickable" onClick={() => setWebcam(!isWebcam)}>
                    <FontAwesomeIcon icon={faCamera} className="" />
                </div>
                {isWebcam ?
                    <div className="attachment-camera-preview">
                        {isWebcamFrozen ?
                            <img src={webcamImage} alt="Webcam preview" />
                            :
                            <Webcam
                                audio={false}
                                height={videoConstraints.renderheight}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                width={videoConstraints.renderwidth}
                                videoConstraints={videoConstraints}
                            />
                        }
                        {renderCameraButtons()}
                    </div>
                    : null}
                <FilePond
                    className="mt-2"
                    allowMultiple={false}
                    server={fpPayload(jobId, jobStep, () => { LoadAttachments(jobId, jobStep) })}
                    credits={false}
                    ref={filepondRef}
                />
            </div>
        }
        else {
            return null;
        }
    }
    const renderCameraButtons = () => {
        return <div>
            {webcamImage && isWebcamFrozen ?
                <div className="row justify-content-center">
                    <input type="text"
                        className="enc-input-100"
                        name="webcamImageName"
                        value={webcamImageName}
                        placeholder="Image Name"
                        onChange={e => setWebCamImageName(e.target.value)}
                    />
                </div>
                : null}
            <div className="row justify-content-center">
                <Button className="enc-button" onClick={() => resetCamera()}>Cancel</Button>&nbsp;
                <Button className="enc-button" onClick={() => webcamSnapshot()}>{isWebcamFrozen ? "Reset" : "Snapshot"}</Button>&nbsp;
                {webcamImage && isWebcamFrozen ?
                    <Button className="enc-button" onClick={() => uploadCamera()}>Upload</Button>
                    : null}
            </div>
        </div>;
    }
    const uploadCamera = () => {
        var fp = filepondRef.current;
        if (fp) {
            fp.addFile(webcamImage).then(item => {
                var n = webcamImageName;
                if (n)
                    item.file.name = n;
                var t = item.file.type; // attempt to append the correct filetype
                t = t.replace("image/", "");
                item.file.name = item.file.name + "." + t;
            });
        }
        resetCamera();
    }
    const resetCamera = () => {
        setWebcam(false);
        setWebcamFrozen(false);
        setWebCamImage('')
        setWebCamImageName('')
    }

    useEffect(() => {
        preventFileLoadOnMissedDragAndDrop();
    })

    return (
        <>
            <ListGroup>
                <ListGroup.Item className="enc-list">
                    <div className="row align-items-center">
                        <FontAwesomeIcon icon={hideAttachments === false ? faEye : faEyeSlash} className="clickable" onClick={() => setHideAttachments(!hideAttachments)} />
                        <div className="col">
                            {title}
                        </div>
                    </div>
                </ListGroup.Item>
                {attachments.length === 0 && <ListGroup.Item className="enc-list">No Attachments Found</ListGroup.Item>}
                {attachments.map((m, idx) => (
                    !hideAttachments || m.favorite ? (
                        <ListGroup.Item key={`Attachment-${m.jobAttachmentId}`} className="enc-list">
                            <div className="row">
                                <div className={`lg-item-favorite lg-item-favorite-${Boolean(m.favorite)}`}>
                                    <FontAwesomeIcon icon={m.favorite === true ? faStarSolid : faStarRegular} className="clickable" onClick={() => FavoriteAttachment(m, idx)} />
                                </div>
                                <div className="col">
                                    <strong>{m.name}</strong>
                                </div>
                                <div className="col text-right">
                                    <FontAwesomeIcon icon={faDownload} className="clickable" onClick={() => GetJobAttachment(m.jobAttachmentId, m.name)} />
                                    {editable &&
                                        <FontAwesomeIcon icon={faTrash} className="clickable ml-2" onClick={() => RemoveAttachment(m.jobAttachmentId)} />
                                    }
                                </div>
                            </div>
                        </ListGroup.Item>
                    ) : null
                )
                )}
            </ListGroup>
            {renderUpload()}
        </>
    )
}


